import type { Attachment } from "@shared/schema.ts";
import { useSession } from "../app/session.tsx";
import { uploadAttachment } from "../lib/api.ts";
import { useTrip } from "../app/trip.tsx";

export function DocumentList({ entityId, files }: { entityId: string; files: Attachment[] }) {
  const { role } = useSession();
  const { refresh } = useTrip();
  const ticketish = files.length === 1 ? "Show document" : "Open";

  return (
    <section>
      <h3 className="serif section-title">Documents</h3>
      {files.length === 0 ? <p className="muted">No document attached yet.</p> : null}
      {files.map((file) => (
        <div className="doc-row" key={file.id}>
          <div>
            <p>{file.filename}</p>
            <p className="muted">{file.contentType}</p>
          </div>
          <a className="btn-secondary" href={`/api/attachments/${file.id}`}>
            {ticketish}
          </a>
        </div>
      ))}
      {role === "owner" ? (
        <label className="field">
          Attach to this record
          <input
            type="file"
            onChange={(e) => {
              const file = e.target.files?.[0];
              if (!file) return;
              void uploadAttachment(file, [entityId]).then(() => refresh());
            }}
          />
        </label>
      ) : null}
    </section>
  );
}
